export default __webpack_public_path__ + "static/media/explore-blue.5f65091b.svg";